export default __webpack_public_path__ + "static/media/home.f9cbdeab.png";